import React from "react";
import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { WorkflowItemDeleteIcon } from "../common/Icon";

const CancelDeleteModal = ({
  deleteModal,
  setDeleteModal,
  deletModalHeading,
  deleteCard,
}) => {
  return (
    <>
      <Transition appear show={deleteModal} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-[99999999]"
          onClose={() => {
            setDeleteModal(false);
          }}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0">
            <div className="fixed inset-0 bg-[#0d10143d]" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div
              className="flex min-h-full items-center justify-center text-center"
              onClick={() => {
                setDeleteModal(false);
              }}>
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95">
                <Dialog.Panel className="overflow-hidden transition-all">
                  <div className="w-full max-w-[330px] md:max-w-[340px] bg-white text-center py-8 px-16 z-10 relative rounded-xl mx-auto text-white">
                    <span className="mx-auto w-[38px] h-[38px] block delete-icon">
                      <WorkflowItemDeleteIcon />
                    </span>
                    <h3 className=" text-base text-black font-semibold mb-4 pt-2">
                      {deletModalHeading}
                    </h3>
                    <div className="flex gap-[11px] justify-center">
                      <button
                        onClick={() => {
                          setDeleteModal(false);
                        }}
                        className="text-sm font-normal rounded-[26px] border border-solid border-transparent  p-[8px_22px] text-white bg-[#D85448] hover:bg-transparent hover:text-[#D85448] hover:border-[#D85448] duration-300 outline-none">
                        Cancel
                      </button>
                      <button
                        onClick={() => deleteCard()}
                        className="text-sm font-normal text-black rounded-[26px] opacity-60 border border-solid border-black p-[8px_22px] hover:bg-transparent hover:text-[#D85448] hover:border-[#D85448] hover:opacity-100 duration-300 outline-none">
                        Delete
                      </button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default CancelDeleteModal;
